import React, { Component } from "react";
import { connect } from "react-redux";

import ProfileComponent from "./ProfileComponent";

export class Profile extends Component {
  render() {
    const { user, navCommunity, onChangeTab, nbResult } = this.props;

    return (
      <ProfileComponent
        user={user}
        navCommunity={navCommunity}
        onChangeTab={onChangeTab}
        nbResult={nbResult}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  user: state.auth.user,
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);



// WEBPACK FOOTER //
// ./src/components/MyMedias/Profile/index.js